import React from "react";

const AboutUs = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold text-center text-[#a6ce37] mb-8">
        About Us
      </h1>
      <div className="bg-white p-6 shadow-lg rounded-lg">
        <p className="text-gray-700 leading-6 mb-4">
          UC8 Australia Pty Ltd (UC8) is an IT and Communications Company
          offering innovative technology-based products and services designed to
          save you money.
        </p>
        <p className="text-gray-700 leading-6 mb-4">
          With a significant network and technology offering spanning over 30
          countries, we are dedicated to providing cost-effective solutions.
        </p>
        <p className="text-gray-700 leading-6 mb-4">
          In 2024, the UC8 Group celebrates 30 years as a leading IT and
          Telecommunication service provider. As a Carriage Service Provider
          (CSP) and Internet Service Provider (ISP), we have built strong
          partnerships with industry leaders such as Cisco, Intel, and
          Microsoft.
        </p>
        <p className="text-gray-700 leading-6 mb-4">
          UC8 was an early adopter of Internet Protocol (IP) Telephony in
          Australia, developing and implementing multiline technology that
          enables unlimited simultaneous calling over our network. This
          innovation offers our clients highly discounted calls and line
          rentals. Additionally, owning our equipment outright allows us to
          provide cost-effective communication solutions to our clients.
        </p>
        <p className="text-gray-700 leading-6 mb-4">
          We offer a large range of IT and communication products designed for
          SME businesses. Our products offer exceptional value for money and
          often result in significant savings. These savings can fund a
          technology upgrade with little to no capital outlay.
        </p>
        <p className="text-gray-700 leading-6 mb-4">
          Getting support is also very important to us. Our national operations
          centre, located in Brisbane, is staffed by a dedicated local team
          providing customer service and support beyond your expectations.
          Simply pick up the phone and talk to a real person.
        </p>
        <p className="text-gray-700 leading-6 mb-4">
          As a Bartercard business member, you are invited to take advantage of
          our products and services. This opportunity allows you to potentially
          reduce your communication costs, save money, receive a technology
          upgrade often funded by the savings, and conserve your cash by
          covering a portion of your costs with Bartercard.
        </p>
        <p className="text-lg text-gray-700 font-bold mt-6">
          “We are excited to contribute to the growth and success of your
          business."
        </p>
        <p className="text-gray-700 mt-4">
          With kind regards,
          <br />
          Christopher Freeburn
          <br />
          CEO
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
